<template lang="pug">
  div(class="billing-documents-cards-wrapper")
    div(
      v-if="additionalDocuments && additionalDocuments.length"
      class="billing-overview__card-arrows"
    )
      v-btn(
        icon
        class="billing-overview__card-arrow"
        :disabled="disablePrev"
        @click="slideDocuments('prev')"
      )
        e-svg-icon arrow-left-gray
      span(class="text-12px fw-300 px-2") {{ step + 1 }} - {{ additionalDocuments.length + 1 }}
      v-btn(
        icon
        class="billing-overview__card-arrow"
        :disabled="disableNext"
        @click="slideDocuments('next')"
      )
        e-svg-icon arrow-right-gray
    billing-documents-plan-card(
      v-if="shownDocumentsPlan"
      :plan="shownDocumentsPlan"
      class="h-100"
      @slideToLastStep="handleSlideToLastStep"
    )
    billing-documents-card(
      v-else-if="!shownDocumentsPlan || isLastStep"
      class="h-100"
    )
</template>

<script>
import { mapGetters } from 'vuex'
import BillingDocumentsPlanCard from '~/modules/billing/components/billing-documents-plan-card'
import BillingDocumentsCard from '~/modules/billing/components/billing-documents-card'
import currencyFormat from '~/mixins/filters/currencyFormat'

export default {
  name: 'BillingDocumentsCards',
  components: {
    BillingDocumentsPlanCard,
    BillingDocumentsCard
  },
  mixins: [currencyFormat],
  data() {
    return {
      step: 0,
      shownDocumentsPlan: null
    }
  },
  computed: {
    ...mapGetters('billing', {
      additionalDocuments: 'additionalDocuments'
    }),
    sortedAdditionalDocumentsByEndDate() {
      const arr = this._.cloneDeep(this.additionalDocuments)
      if (!arr) return []
      return arr.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())
    },
    disablePrev() {
      return this.step === 0
    },
    disableNext() {
      return this.step === this.additionalDocuments.length
    },
    isLastStep() {
      return this.step === this.additionalDocuments.length
    }
  },
  watch: {
    additionalDocuments: {
      handler(val) {
        if (val && val.length && !this.shownDocumentsPlan) {
          this.shownDocumentsPlan = this.sortedAdditionalDocumentsByEndDate[0]
        }
      },
      immediate: true
    }
  },
  methods: {
    slideDocuments(where) {
      if (where === 'prev') {
        this.step--
      } else {
        this.step++
      }
      this.shownDocumentsPlan = this.sortedAdditionalDocumentsByEndDate[this.step]
    },
    handleSlideToLastStep() {
      this.step = this.sortedAdditionalDocumentsByEndDate.length
      this.shownDocumentsPlan = null
    }
  }
}
</script>

<style scoped lang="scss">
.billing-documents-cards-wrapper {
  position: relative;
}
</style>
